import * as React from 'react';
import { Trans } from '@lingui/react/macro';

import { Modal } from '../../_core/ui/modal.component';
import { Button, ViewDetailsButton } from '../../ui/button';
import { useUserContext } from '../../../providers/user/user.provider';
import { useAuthContext } from '../../../providers/auth.provider';
import { openFranklinApp } from './franklin.utils';

const SHOWN_KEY_PREFIX = 'hasShownFranklinLoanModal:';

// sessionStorage so the prompt comes back on each new sign-in session but not on every route
// change or refresh within one. Storage can throw (private mode, blocked site data); worst case
// the modal shows again.
const hasShownThisSession = (uid: string) => {
  try {
    return sessionStorage.getItem(SHOWN_KEY_PREFIX + uid) === 'true';
  } catch {
    return false;
  }
};

const markShownThisSession = (uid: string) => {
  try {
    sessionStorage.setItem(SHOWN_KEY_PREFIX + uid, 'true');
  } catch {
    // ignore
  }
};

export const FranklinLoanModal = () => {
  const { user } = useUserContext();
  const { firebaseUser } = useAuthContext();
  const uid = firebaseUser?.uid;
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (uid && user?.hasActiveFranklinLoan && !hasShownThisSession(uid)) {
      setOpen(true);
    }
  }, [uid, user?.hasActiveFranklinLoan]);

  const handleClose = () => {
    if (uid) markShownThisSession(uid);
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="p-3 flex flex-col w-full">
        <h3 className="text-lg text-center font-medium mb-2">
          <Trans>Are you here for your loan with Franklin Credit?</Trans>
        </h3>
        <div className="flex flex-col justify-center items-center gap-2 mt-4">
          <Button
            onClick={() => {
              handleClose();
              openFranklinApp();
            }}
            variant="secondary"
            size="lg"
          >
            <Trans>Sign in at the Franklin app</Trans>
          </Button>
          <ViewDetailsButton onClick={handleClose}>
            <Trans>Continue to Solve Finance</Trans>
          </ViewDetailsButton>
        </div>
      </div>
    </Modal>
  );
};
